/**
 * @file 地图服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';
import {assign} from 'lodash';

export default class MapServiceDetailModel extends FormModel {
    /**
     * @override
     */
    title = '';

    serviceType = 'map';
    storeListInfo = {
        result: []
    };
    pageSizes = [15, 30, 50];

    customFields = [];

    init() {
        super.init();

        this.detailRequester = this.api.appServiceMapStoreTableInfo;

        if (this.isAdmin) {
            this.storeListRequester = this.api.appServiceMapStoreList;
        }
    }

    getDefaultArgs() {
        return {
            serviceId: this.getRouteParams().serviceId
        };
    }

    yesAndNoMap = this.getConstantMap('YES_AND_NO');

    adaptData(data) {
        data.sync = String(data.sync);
        assign(data, data.row);
        data.name = data.serviceName;
        this.customFields = data.fields || [];
        return super.adaptData(data);
    }

    async requestStoreList(params = {}) {
        let {pageSize, pageNo = 1, order = 'desc'} = params;
        this.storeListInfo = await this.storeListRequester({
            order,
            pageSize: pageSize || this.storeListInfo.pageSize || this.pageSizes[0],
            pageNo,
            serviceId: this.getRouteParams().serviceId
        });
    }
}

